module.exports = __webpack_public_path__ + "static/media/chess-pawn.63ce6eb9.svg";